import { gql } from "@apollo/client";

// Get tenant's token configuration (branding)
export const GET_PUBLIC_REWARD_TOKEN_CONFIG = gql`
  query PublicRewardTokenConfig {
    publicRewardTokenConfig {
      id
      tokenName
      tokenNamePlural
      tokenIcon
      tokenColor
      tokenValue
      defaultExpiryMonths
      isActive
    }
  }
`;

// Get current user's reward balance
export const GET_MY_REWARD_BALANCE = gql`
  query MyRewardBalance {
    myRewardBalance {
      clientId
      clientName
      activeTokens
      totalValue
      expiringWithin30Days
    }
  }
`;

// Get current user's reward tokens
export const GET_MY_REWARD_TOKENS = gql`
  query MyRewardTokens {
    myRewardTokens {
      id
      tokenNumber
      clientId
      clientName
      status
      value
      issueReason
      issueDetails
      referredClientName
      issuedAt
      issuedByName
      expiresAt
      redeemedAt
      redeemedFor
      cancelledAt
      cancelledReason
    }
  }
`;

// Get current user's reward transactions
export const GET_MY_REWARD_TRANSACTIONS = gql`
  query MyRewardTransactions {
    myRewardTransactions {
      id
      tokenId
      tokenNumber
      transactionType
      previousStatus
      newStatus
      reason
      details
      performedByName
      performedAt
    }
  }
`;

// Get leaderboard - top token earners (public)
export const GET_REWARD_LEADERBOARD = gql`
  query RewardLeaderboard($limit: Int) {
    rewardLeaderboard(limit: $limit) {
      clientId
      clientName
      totalEarned
      activeTokens
      redeemedTokens
      totalValue
      rank
    }
  }
`;

// Get a single reward token by ID (public - for email links)
export const GET_PUBLIC_REWARD_TOKEN = gql`
  query PublicRewardToken($id: ID!) {
    publicRewardToken(id: $id) {
      id
      tokenNumber
      clientId
      clientName
      status
      value
      issueReason
      issueDetails
      referredClientName
      issuedAt
      issuedByName
      expiresAt
      redeemedAt
      redeemedFor
      cancelledAt
      cancelledReason
    }
  }
`;
